/** To add new mode, add it to the enum
 *  and you will get automatically the mode API
 *  from  stageModesAPI
 */
export var StageModes;
(function (StageModes) {
    StageModes["Selected"] = "Selected";
})(StageModes || (StageModes = {}));
const getComponentsStageModes = (editorAPI) => editorAPI.componentsStageModes;
const getStageMode = (editorAPI) => getComponentsStageModes(editorAPI).StageMode;
const getEnterMode = (editorAPI, mode) => (compRef) => getComponentsStageModes(editorAPI).enter(compRef, getStageMode(editorAPI)[mode]);
const getExitMode = (editorAPI, mode) => (compRef) => getComponentsStageModes(editorAPI).exit(compRef, getStageMode(editorAPI)[mode]);
const getIsInMode = (editorAPI, mode) => (compRef) => getComponentsStageModes(editorAPI).isIn(compRef, getStageMode(editorAPI)[mode]);
const getSelectedCompRef = (editorAPI) => {
    const [selectedCompRef] = editorAPI.selection.getSelectedComponents();
    return selectedCompRef;
};
const modeGetterFactory = (mode) => (editorAPI) => ({
    /** enters component into stage mode
     * @param compRef - component reference to enter stage mode, if not provided, selected component will be used
     * @returns void
     */
    enter: (compRef) => getEnterMode(editorAPI, mode)(compRef || getSelectedCompRef(editorAPI)),
    /** exits component from stage mode
     * @param compRef - component reference to exit stage mode, if not provided, selected component will be used
     * @returns void
     */
    exit: (compRef) => getExitMode(editorAPI, mode)(compRef || getSelectedCompRef(editorAPI)),
    /** checks if component is in stage mode
     * @param compRef - component reference to check if in stage mode, if not provided, selected component will be used
     * @returns boolean
     */
    isIn: (compRef) => getIsInMode(editorAPI, mode)(compRef || getSelectedCompRef(editorAPI)),
});
/** Stage modes API
 * @example
 * const selectModeAPI = stageModesAPI.selected(editorAPI);
 * // enter stage mode
 * selectModeAPI.enter();
 * // exit stage mode
 * selectModeAPI.exit();
 * // check if component is in stage mode
 * selectModeAPI.isIn();
 * // enter stage mode for specific component
 * selectModeAPI.enter(compRef);
 */
export const stageModesAPI = Object.values(StageModes).reduce((acc, mode) => ({ ...acc, [mode.toLowerCase()]: modeGetterFactory(mode) }), {});
//# sourceMappingURL=modes.getters.js.map